import { CryptoProfiles } from '@factorin/domain';

import { get, post, remove, withUrl, ItemRequest } from '../rest';


type AddCryptoProfile = {
    base64certificate: string;
}

const cryptoProfilesPart = withUrl('cryptoprofiles');

export const cryptoProfiles = {
    list: get<void, CryptoProfiles.UserCryptoProfile[]>(cryptoProfilesPart),

    add: post<AddCryptoProfile, void>(
        ({ base64certificate }) => cryptoProfilesPart({
            body: {
                base64certificate,
            },
        }),
    ),

    remove: remove<ItemRequest, void>(
        ({ id }) => cryptoProfilesPart({
            path: `${id}`,
        }),
    ),
};
